import { Select } from '@truepill/react-capsule'
import { getAdornment } from '../CreateRuleSetPage'

const FIELD_OPTIONS = [
  { label: 'Customer ID', value: 'customer_id' },
  { label: 'OTC Products', value: 'otc_products' },
  { label: 'NDCs', value: 'ndcs' },
  { label: 'Ship To State', value: 'ship_to_state' },
  { label: 'Ship To Zip', value: 'ship_to_zip' },
  { label: 'Number of OTC Products', value: 'number_of_otc_products' },
  { label: 'Number of Medications', value: 'number_of_medications' },
  { label: 'GPIs', value: 'gpis' },
  { label: 'Prescription Location IDs', value: 'prescription_location_ids' },
  { label: 'Payment Type', value: 'payment_type' },
]

const FieldSelect = ({
  value,
  onChange,
  state,
  helperText,
}: {
  value: string
  onChange: (val: string) => void
  state: 'error' | 'default'
  helperText?: string
}) => {
  return (
    <Select
      label="Field"
      value={FIELD_OPTIONS.find(opt => opt.value === value) || null}
      onChange={selected => {
        if (!selected) return
        onChange(selected.value)
      }}
      options={FIELD_OPTIONS}
      selectedKey="label"
      state={state}
      helperText={helperText}
      endAdornment={getAdornment(
        'Target field for this condition. If the field you need isn’t listed, please contact an engineer.',
      )}
    />
  )
}

export default FieldSelect
